/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import ClientStats from "shared/util/ClientStats";
import isApp from "shared/util/isApp";
import { getQuery } from "./util/helpers";
import formattedCameFromParam from "analytics/util/cameFrom";
import { getValueForPromoDesign } from "analytics/util/queryParamsMap";

import {
	LOAD,
	SET_SELECTED_PRODUCT_PACKAGE,
	OPEN_PAYMENT_MODAL,
	SET_PRODUCT_PACKAGES,
} from "ducks/alist_packages";

import {
	PRODUCT_SUBTYPES,
} from "shared/payment/constants";

const EXP_CLIENTSTAT_MAP = {
	[PRODUCT_SUBTYPES.BOOST]: "boost",
	[PRODUCT_SUBTYPES.ALIST]: "alist",
	[PRODUCT_SUBTYPES.ALISTPREMIUM]: "alist",
	[PRODUCT_SUBTYPES.INCOGNITO]: "incognito",
};

const productName = EXP_CLIENTSTAT_MAP.ALIST;

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function alistPackages(state, action) {
	switch (action.type) {
		case LOAD: {
			let platform;

			if (!isApp()) {
				platform = process.env.PLATFORM;
			} else if (window.APP_PLATFORM && window.APP_PLATFORM === "android") {
				platform = "android";
			}

			const statname = `purchases - platform:${platform} - product:${productName} - packages displayed`;

			ClientStats.update({
				statname,
				skipDelay: true,
				unique: true,
			});

			return;
		}

		case SET_PRODUCT_PACKAGES: {
			const { productPackages, isPremium, rateCardName } = action.payload;
			const cameFrom = formattedCameFromParam("alist");
			const promoDesignQuery = getQuery("pd");
			const promoDesignEventAttr = promoDesignQuery ? getValueForPromoDesign(promoDesignQuery) : "";

			Analytics.logUIEvent(
				Analytics.eventNames.viewedRateCard,
				{
					data: {
						"feature": isPremium ? "alist premium" : "alist",
						"feature type": "subscription",
						"rate card name": rateCardName,
						"mothly mix": productPackages.map((product) => product.subPeriod)
							.reverse().join(", "),
						"total monthly price": productPackages.map((product) => product.initialPrice / 100)
							.reverse().join(", "),
						"upsell logic": action.payload.discountId,
						cameFrom,
						"source": getQuery("source"),
						"promo design": promoDesignEventAttr,
						"promo id": cameFrom,
					},
				},
			);

			return;
		}

		case SET_SELECTED_PRODUCT_PACKAGE: {
			const { selectedProductPackage, isPremium, rateCardName } = action.payload;
			const { total, subPeriod, productSubtype } = selectedProductPackage;
			const promoDesignQuery = getQuery("pd");
			const promoDesignEventAttr = promoDesignQuery ? getValueForPromoDesign(promoDesignQuery) : "";

			Analytics.logUIEvent(
				Analytics.eventNames.purchasesSelectedPlanOnAlistUpsell,
				{
					data: {
						"Plan duration in months": subPeriod,
						"gross proceeds in local currency": total / 100,
						"Package": productSubtype === PRODUCT_SUBTYPES.ALIST_PREMIUM ?
							"Premium" :
							"Basic",

					},
				},
			);

			Analytics.logUIEvent(
				Analytics.eventNames.selectedPackageOnRateCard,
				{
					data: {
						"feature": isPremium ? "alist premium" : "alist",
						"feature type": "subscription",
						"rate card name": rateCardName,
						"duration in months": selectedProductPackage.subPeriod,
						"total monthly price": selectedProductPackage.initialPrice / 100,
						"source": getQuery("source"),
						"promo design": promoDesignEventAttr,
						"promo id": formattedCameFromParam("alist"),
					},
				},
			);

			return;
		}

		case OPEN_PAYMENT_MODAL: {
			const { isPaypal } = action.payload;
			const { selectedProductPackage } = state;
			const { total, subPeriod, productSubtype } = selectedProductPackage;
			let platform;

			const eventName = isPaypal ?
				Analytics.eventNames.purchasesSelectSubscribePaypal :
				Analytics.eventNames.purchasesSelectedSubscribeOnAlistUpsell;

			Analytics.logUIEvent(
				eventName,
				{
					data: {
						"Plan duration in months": subPeriod,
						"gross proceeds in local currency": total / 100,
						"Package": productSubtype === PRODUCT_SUBTYPES.ALIST_PREMIUM ?
							"Premium" :
							"Basic",

					},
				},
			);

			if (!isApp()) {
				platform = process.env.PLATFORM;
			} else if (window.APP_PLATFORM && window.APP_PLATFORM === "android") {
				platform = "android";
			}

			const statname = `purchases - platform:${platform} - product:${productName} - option selected`;

			ClientStats.update({
				statname,
				skipDelay: true,
				unique: true,
			});

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/alist_packages.js